import * as angular from 'angular';
import {hydrometComponent, configStates} from './hydromet.component';
import homeComponent from './home/home.component';
import organizationComponent from './organization/organization.component';
import toolbarComponent from './toolbar/toolbar.component';
import sidenavComponent from './sidenav/sidenav.component';
import helpComponent from './help/help.component';
import aboutComponent from './about/about.component';
import invitationsComponent from './invitations/invitations.component';
import {SidenavService} from './sidenav/sidenav.service';

import OrganizationService from './organization/organization.service';
import userManagement from './userManagement/userManagement.component';
import userDetails from './userManagement/details/userDetails.component';
import resetPasswordComponent from './resetPassword/reset-password.component';
import timeseriesComponent from './timeseries/timeseries.component';
import timeseriesNewComponent from './timeseriesNew/timeseries-new.component';
import seasonalFrequencyManagerComponent from './organization/seasonal-frequency-manager.component';
import accessComponent from './access/access.component';
import cmsComponent from './cms/cms.component';
import wizardComponent from '../common/components/wizard/wizard.component';
import paginationControlsComponent from '../common/components/paginationControls/paginationControls.component';
import changePasswordFormComponent from './userManagement/details/change-password-form.component';
import reportingTemplatesComponent from './organization/reporting-templates.component';


export default angular.module('imomo.hydromet', [])
    .component('hydromet', hydrometComponent)
    .component('hydrometHome', homeComponent)
    .component('hydrometOrganization', organizationComponent)
    .component('hydrometHelp', helpComponent)
    .component('hydrometAbout', aboutComponent)
    .component('hydrometInvitations', invitationsComponent)
    .component('userManagement', userManagement)
    .component('userDetails', userDetails)
    .component('hydrometToolbar', toolbarComponent)
    .component('hydrometSidenav', sidenavComponent)
    .component('resetPassword', resetPasswordComponent)
    .component('hydrometTimeseries', timeseriesComponent)
    .component('hydrometTimeseriesNew', timeseriesNewComponent)
    .component('seasonalFrequencyManager', seasonalFrequencyManagerComponent)
    .component('access', accessComponent)
    .component('cms', cmsComponent)
    .component('wizard', wizardComponent)
    .component('paginationControls', paginationControlsComponent)
    .component('changePasswordForm', changePasswordFormComponent)
    .component('reportingTemplates', reportingTemplatesComponent)
    .service('sidenavService', SidenavService)
    .service('organizationService', OrganizationService)
    .config(configStates)
    .name;



/** WEBPACK FOOTER **
 ** ./app/hydromet/hydromet.module.ts
 **/